import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    if (payload?.id) {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_TEAMMATE_UPDATE, {
        queryParams: { service: 'rapidoo-admin' }
      })
    }
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_TEAMMATE_ADD, {
      queryParams: { service: 'rapidoo-admin' }
    })
  },

  method(payload) {
    return 'POST'
  },

  format(payload) {
    const nameParts = (payload.name || '').trim().split(' ')
    const firstName = nameParts.shift() || ''
    const lastName = nameParts.join(' ') || firstName

    const data = {
      firstName,
      lastName,
      email: payload.email,
      role: Array.isArray(payload.roles) && payload.roles.length > 0
        ? payload.roles[0].name
        : undefined,
      service: 'rapidoo-admin',
      permissions: payload.permissions || [],
    }

    if (payload.password && String(payload.password).trim().length > 0) {
      data.password = String(payload.password).trim()
    }

    return data
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de l'enregistrement de l'équipier",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Équipier enregistré avec succès',
      data: raw.data,
    }
  },
}
